import {Component, OnInit, HostListener, AfterViewInit} from '@angular/core';

declare var $: any;

@Component({
    selector: 'app-modal',
    template: '<ng-container></ng-container>',
    standalone: false
})
export class BaseModal implements OnInit, AfterViewInit {

    callBackOnClose: any;
    dataOnClose: any;
    parentDialog: any;
    parent: any;
    hideParentOnClose: any;

    @HostListener('document:click', ['$event']) handleClick(event: any) {
        // Avoid conflicting with bootstrap / ngx-bootstrap modal wrappers
        if (event.target['className'] === 'modal fade in'
            || event.target['className'] === 'modal-dialog'
            || event.target.dataset?.['closeModal']) {
            const result = this.dataOnClose ? this.dataOnClose : true;
            this.close(result);
        }
    }

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.setWidthAttr();
    }

    close(result: any, data?: any) {
        if (this.callBackOnClose) {
            this.callBackOnClose.call();
        }

        $('body').removeClass('modal-open');

        // @ts-ignore — subclasses inject dialog: DialogRef
        this['dialog'].close(result, 500);
        this.hideDialog();
        if (!this.hideParentOnClose) {
            this.showParentDialog();
        }
    }

    closeAll() {
        // @ts-ignore
        this['dialog'].close();
        if (this.parent) {
            this.parent.closeAll();
        }
    }

    showParentDialog() {
        if (this.parent) {
            this.parentDialog = this.parent.dialog;
        }
        if (this.parentDialog?.overlayRef?.location?.nativeElement) {
            $(this.parentDialog.overlayRef.location.nativeElement).css('display', 'block');
        }
    }

    hideParentDialog(parentContext?: any): void {
        if (parentContext) {
            this.parentDialog = parentContext.dialog;
        } else if (this.parent) {
            this.parentDialog = this.parent.dialog;
        }

        if (this.parentDialog?.overlayRef?.location?.nativeElement) {
            $(this.parentDialog.overlayRef.location.nativeElement).css('display', 'none');
        }
    }

    hideDialog(): void {
        // @ts-ignore
        const el = this['dialog']?.overlayRef?.location?.nativeElement;
        if (el) {
            $(el).css('display', 'none');
        }
    }

    showDialog() {
        // @ts-ignore
        const el = this['dialog']?.overlayRef?.location?.nativeElement;
        if (el) {
            $(el).css('display', 'block');
        }
    }

    setWidthAttr() {
        if (window.screen.width < 992) {
            // @ts-ignore
            const el = this['dialog']?.overlayRef?.location?.nativeElement;
            if (el) {
                $(el).find('.db-new-popup').css('width', (window.screen.width - 40) + 'px');
            }
        }
    }
}
